
import { appApi } from '../../../store/app.api';
import { appEndpoint } from '../../../store/app.endpoint';
import { CommandRequest } from '../../../libs/auth/utilities/command-request';

export const teamsApi = appApi.injectEndpoints({
  endpoints: (build) => ({
    getTeams: build.query<any, void>({
      query: () => ({
        url: appEndpoint.teamProfiles,
        method: 'get',
      }),
      providesTags: ['Teams'],
    }),
    addTeam: build.mutation<any, CommandRequest>({
      query: (data) => ({
        url: appEndpoint.teamProfiles,
        method: 'post',
        data: data.body
      }),
      invalidatesTags: (result) => (result ? ["Teams"] : []),
    }),

    updateTeam: build.mutation<any, CommandRequest>({
      query: (data) => ({
        url: `${appEndpoint.teamProfiles}/${data.id}?_method=put`,
        method: 'post',
        data: data.body
      }),
      invalidatesTags: (result) => (result ? ["Teams"] : []),
    }),
    

    deleteTeam: build.mutation<void, string>({
      query: (id) => ({
        url: `${appEndpoint.teamProfiles}/${id}`,
        method: 'delete',
      }),
      invalidatesTags: ['Teams'],
    }),

    reorderTeamProfiles: build.mutation<any, { orders: Array<{ id: number; order_number: number }> }>({
      query: (data) => ({
        url: appEndpoint.reorderTeamProfiles,
        method: 'post',
        data: data
      }),
      invalidatesTags: ['Teams'],
    }),

    activateTeam: build.mutation<any, number>({
      query: (id) => ({
        url: `${appEndpoint.teamProfiles}/${id}/activate`,
        method: 'post',
      }),
      invalidatesTags: ['Teams'],
    }),

    deactivateTeam: build.mutation<any, number>({
      query: (id) => ({
        url: `${appEndpoint.teamProfiles}/${id}/deactivate`,
        method: 'post',
      }),
      invalidatesTags: ['Teams'],
    }),

  }),
  overrideExisting: false,
});

export const {
  useGetTeamsQuery,
  useDeleteTeamMutation,
  useUpdateTeamMutation,
  useAddTeamMutation,
  useReorderTeamProfilesMutation,
  useActivateTeamMutation,
  useDeactivateTeamMutation
} = teamsApi;